import { useState } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useGetSB156DocumentsQuery, useLazyGetDownloadDocumentQuery } from "../redux/documentsSlice";
import { handleDocumentDownload } from "../utilities/documentsUtils";
import { useDocumentTitle } from "../hooks/useDocumentTitle";

const SB156DocumentsTable = () => {
  useDocumentTitle("SB 156 Documents");

  const [filterCounty, setFilterCounty] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const { data: sb156Documents = [] } = useGetSB156DocumentsQuery();
  const [triggerDownloadDocument] = useLazyGetDownloadDocumentQuery();

  const counties = [...new Set(sb156Documents.map((doc) => doc.county))].sort();

  const filteredDocuments = sb156Documents.filter(
    (doc) =>
      (filterCounty === "" || doc.county === filterCounty) &&
      (searchTerm === "" || doc.uploadedFileName.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  return (
    <div className="container mt-3">
      <h1 className="h3 mb-3">SB 156 Documents</h1>
      <div className="visually-hidden" aria-live="polite" aria-atomic="true">
        {filteredDocuments.length === 0
          ? "No documents match the current filters."
          : `Showing ${filteredDocuments.length} document${filteredDocuments.length === 1 ? "" : "s"}.`}
      </div>
      <div className="mb-3" role="search" aria-label="Document filters">
        <select
          value={filterCounty}
          onChange={(e) => setFilterCounty(e.target.value)}
          className="form-select me-2"
          aria-label="Select County"
        >
          <option value="">Select County</option>
          {counties.map((county, index) => (
            <option key={index} value={county}>
              {county}
            </option>
          ))}
        </select>
        <input
          type="text"
          placeholder="Search by file name..."
          aria-label="Search by file name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="form-control mt-2"
        />
      </div>
      {/* Table layout */}
      <div className="table-responsive d-none d-md-block">
        <table className="table table-striped table-sm">
          <thead>
            <tr>
              <th className="align-middle">Action</th>
              <th className="align-middle">State</th>
              <th className="align-middle">County</th>
              <th className="align-middle">Uploaded File Name</th>
            </tr>
          </thead>
          <tbody>
            {filteredDocuments.map((doc, index) => (
              <tr key={index}>
                <td className="align-middle">
                  <button
                    className="btn custom-download-button"
                    onClick={() =>
                      handleDocumentDownload(
                        doc.uploadedFileName,
                        doc.storedFileName,
                        process.env.REACT_APP_SB156_CONTAINER,
                        triggerDownloadDocument
                      )
                    }
                    aria-label={`Download ${doc.uploadedFileName}`}
                  >
                    <i className="bi bi-download" aria-hidden="true"></i>
                  </button>
                </td>
                <td className="align-middle">{doc.state}</td>
                <td className="align-middle">{doc.county}</td>
                <td
                  className="align-middle"
                  title={doc.uploadedFileName}
                  style={{ maxWidth: "150px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}
                >
                  {doc.uploadedFileName}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Card layout */}
      <div className="d-block d-md-none">
        {filteredDocuments.map((doc, index) => (
          <div key={index} className="card mb-3">
            <div className="card-body">
              <h5 className="card-title" title={doc.uploadedFileName}>
                {doc.uploadedFileName}
              </h5>
              <p className="card-text">State: {doc.state}</p>
              <p className="card-text">County: {doc.county}</p>
              <button
                className="btn custom-download-button"
                onClick={() =>
                  handleDocumentDownload(
                    doc.uploadedFileName,
                    doc.storedFileName,
                    process.env.REACT_APP_SB156_CONTAINER,
                    triggerDownloadDocument
                  )
                }
                aria-label={`Download ${doc.uploadedFileName}`}
              >
                <i className="bi bi-download" aria-hidden="true"></i> Download
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SB156DocumentsTable;
